import React from "react";
import { PaperClipIcon } from "@heroicons/react/24/outline";

const formatSize = (bytes) => {
  if (bytes == null || Number.isNaN(Number(bytes))) return null;
  const n = Number(bytes);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

const AnswerFile = ({ attachments }) => {
  const list = Array.isArray(attachments) ? attachments : [];
  if (list.length === 0) {
    return <p className="text-sm italic text-gray-400">No files uploaded</p>;
  }
  return (
    <ul className="space-y-1.5">
      {list.map((a) => {
        const name = a.upload_name || a.file_name || "Attachment";
        const size = formatSize(a.size_bytes);
        return (
          <li
            key={a.attachment_id}
            className="flex items-center gap-2 text-sm text-gray-800 bg-gray-50 border border-gray-200 rounded px-2 py-1.5"
          >
            <PaperClipIcon className="h-4 w-4 text-gray-500 shrink-0" />
            <span className="truncate" title={name}>
              {name}
            </span>
            {size ? <span className="text-xs text-gray-500 ml-auto shrink-0">{size}</span> : null}
          </li>
        );
      })}
    </ul>
  );
};

export default AnswerFile;
